import React, { useEffect } from 'react';
import Plan_Details from '../../component/Plan_Details';
import './style.scss';

const PlanDetails = () => {
  useEffect(() => {
    window.document.title =
      'ImageEdit.ai | Generate or replace Catalogue Images with AI Models |Subscription Plan Details';
  }, []);
  return (
    <div className="plan_details">
      <Plan_Details />
    </div>
  );
};

export default PlanDetails;
